import { useEffect } from "react";

import { getPrefill } from "../useLearning";
import { ACTION } from "./editorModel";
import { sessionFromPrefill } from "./editorPrefill";

/**
 * Fetches the server's prefill for this chat once, after the editor has already opened on the local fallback, and hands it to the
 * model (which replaces an untouched form and merges into a touched one). Any failure (not in a diagnosis, 503, offline) is
 * silent: the editor keeps what it has. Never gates the eligibility check or the save.
 */
export default function usePrefill({ sessionId, dispatch }) {
  useEffect(() => {
    if (!sessionId) return undefined;
    const controller = new AbortController();
    getPrefill(sessionId, { signal: controller.signal })
      .then((data) => {
        const session = sessionFromPrefill(data);
        if (session && !controller.signal.aborted) dispatch({ type: ACTION.APPLY_PREFILL, session });
      })
      .catch(() => {});
    return () => controller.abort();
  }, [sessionId, dispatch]);
}
